import { Link } from "react-router-dom";

const footerLinks = [
  {
    title: "内容导航",
    links: [
      { name: "剧情解析", path: "/category/plot-analysis" },
      { name: "演员阵容", path: "/category/cast" },
      { name: "观看指南", path: "/category/watching-guide" },
      { name: "影评点评", path: "/category/reviews" },
      { name: "相关推荐", path: "/category/recommendations" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { name: "关于我们", path: "/about" },
      { name: "联系方式", path: "/about#contact" },
      { name: "用户评价", path: "/about#testimonials" },
    ],
  },
  {
    title: "友情链接",
    links: [
      { name: "豆瓣电影", path: "https://movie.douban.com", external: true },
      { name: "IMDb", path: "https://www.imdb.com", external: true },
      { name: "韩国电影振兴委员会", path: "https://www.kofic.or.kr", external: true },
    ],
  },
];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="lg:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-movie-2-line text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-lg font-bold text-background-50">
                  妈妈的朋友2
                </span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed mb-4">
                致力于为影迷提供「妈妈的朋友2」最全面的剧情解析、演员阵容介绍、观看指南和影评点评，畅享优质影视体验。
              </p>
              <div className="flex items-center gap-3">
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-all duration-200"
                  aria-label="微博"
                  rel="nofollow"
                >
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-all duration-200"
                  aria-label="微信"
                  rel="nofollow"
                >
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-all duration-200"
                  aria-label="豆瓣"
                  rel="nofollow"
                >
                  <i className="ri-douban-line text-sm"></i>
                </a>
              </div>
            </div>

            {footerLinks.map((section) => (
              <div key={section.title}>
                <h3 className="font-heading text-sm font-semibold text-background-50 mb-4">
                  {section.title}
                </h3>
                <ul className="space-y-3">
                  {section.links.map((link) =>
                    link.external ? (
                      <li key={link.path}>
                        <a
                          href={link.path}
                          target="_blank"
                          rel="noopener noreferrer nofollow"
                          className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200"
                        >
                          {link.name}
                        </a>
                      </li>
                    ) : (
                      <li key={link.path}>
                        <Link
                          to={link.path}
                          className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200"
                        >
                          {link.name}
                        </Link>
                      </li>
                    )
                  )}
                </ul>
              </div>
            ))}
          </div>

          <div className="border-t border-background-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {currentYear} 妈妈的朋友2 影迷资讯站. 本站为非官方影迷资讯平台，内容仅供学习交流使用。
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors" rel="nofollow">
                使用条款
              </a>
              <a
                href="#top"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-all duration-200"
                aria-label="回到顶部"
              >
                <i className="ri-arrow-up-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}